<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
	export default {
		data() {
			return {
				common_info: {
					store: {}
				},
			};
		},
		methods: {
			getdata(){
				var that=this;
				this.$api.store().then((res) => {
					if (res.code == 0) {
						// console.log(res)
						sessionStorage.setItem('appStore',JSON.stringify(res.data))
						document.title=res.data.store.name;
					}
				})
				.catch((err) => {
					this.common.message(this, err);
				});
			},
		},
		created() {
			this.getdata();
			let that = this; 
			this.common.getCommonInfo(this,function(){
				/* that.ttshop_name = that.common_info.store.name;
				document.title = that.common_info.store.name; */
				var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
				link.type = "image/x-icon";
				link.rel = "shortcut icon";
				link.href = that.common_info.store.icon;
				document.getElementsByTagName("head")[0].appendChild(link);
				/* let head = document.getElementsByTagName("head");
				let meta = document.createElement("meta");
				document.querySelector('meta[name="keywords"]').setAttribute("content", that.common_info.store.seo_key);
				document.querySelector('meta[name="description"]').setAttribute("content", that.common_info.store.seo_desc); */
			});
			
		},
	};
</script>
<style lang="scss">
</style>
